import React from "react"
import Nav from "../Components/Outlets/Nav"
import Footer from "../Components/Outlets/Footer"
import { Link } from "react-router-dom"

const Contact = () => {
	return (
		<div>
			<Nav />
			<div className="page-breadcrumb-bar">
				<div className="container-main">
					<div className="breadcrumb-inner">
						<h1 className="breadcrumb-page-title montserrat">Contact Us</h1>
						<nav className="breadcrumb-nav-links">
							<Link to="/">Home</Link>
							<i className="ri-arrow-right-s-line"></i>
							<span>Contact Us</span>
						</nav>
					</div>
				</div>
			</div>

			<div className="contact-page-dv">
				<div className="container-main">

					<div className="row mb-5">
						<div className="col-lg-3 col-md-6 mb-4">
							<div className="contact-info-card">
								<div className="contact-info-icon">
									<i className="ri-map-pin-2-line"></i>
								</div>
								<h5>Our Location</h5>
								<p>Branmont Global Boys Secondary School, Kuttiady, Calicut, Kerala</p>
							</div>
						</div>
						<div className="col-lg-3 col-md-6 mb-4">
							<div className="contact-info-card">
								<div className="contact-info-icon">
									<i className="ri-phone-line"></i>
								</div>
								<h5>Phone Number</h5>
								<p>+91 92924 59330</p>
							</div>
						</div>
						<div className="col-lg-3 col-md-6 mb-4">
							<div className="contact-info-card">
								<div className="contact-info-icon">
									<i className="ri-mail-send-line"></i>
								</div>
								<h5>Email Address</h5>
								<p>branmontcampus@gmail.com</p>
							</div>
						</div>
						<div className="col-lg-3 col-md-6 mb-4">
							<div className="contact-info-card">
								<div className="contact-info-icon">
									<i className="ri-time-line"></i>
								</div>
								<h5>School Hours</h5>
								<p>Working hours: 24 hours<br />Office time: 8 AM - 5 PM</p>
							</div>
						</div>
					</div>

					<div className="row justify-content-center mb-5">
						<div className="col-lg-8">
							<div className="contact-form-card">
								<div className="contact-form-top">
									<h3 className="contact-form-heading montserrat">Send Us a Message</h3>
									<p className="contact-form-sub">We would love to hear from you. Fill in the form and we will get back to you shortly.</p>
								</div>
								<form>
									<div className="row">
										<div className="col-lg-6">
											<div className="contact-form-group">
												<label>Full Name</label>
												<input type="text" className="form-control" placeholder="Your full name" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="contact-form-group">
												<label>Phone Number</label>
												<input type="tel" className="form-control" placeholder="Your phone number" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="contact-form-group">
												<label>Email Address</label>
												<input type="email" className="form-control" placeholder="Your email address" />
											</div>
										</div>
										<div className="col-lg-6">
											<div className="contact-form-group">
												<label>Place</label>
												<input type="text" className="form-control" placeholder="Your city / place" />
											</div>
										</div>
										<div className="col-lg-12">
											<div className="contact-form-group">
												<label>Message</label>
												<textarea className="form-control" placeholder="Write your message here..." rows="5"></textarea>
											</div>
										</div>
										<div className="col-lg-12 text-center mt-2">
											<button type="submit" className="btn contact-submit-btn">
												Send Message <i className="ri-send-plane-2-line"></i>
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-lg-12">
							<div className="contact-map-wrap">
								<iframe
									title="Our Location"
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7814.915433292665!2d75.73928877711298!3d11.66193881082251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba67e5a169a7bb7%3A0x8d6e0e78fb9b24e3!2sSirajul%20Huda%20English%20Medium%20School!5e0!3m2!1sen!2sin!4v1738305122696!5m2!1sen!2sin"
									width="100%"
									height="440"
									allowFullScreen=""
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
								></iframe>
							</div>
						</div>
					</div>

				</div>
			</div>

			<Footer />
		</div>
	)
}

export default Contact
